import moment from "moment-timezone";
import { initImage } from "../media";
import fbImage from "../../../public/images/common/post_facebook@3x.png";
import twImage from "../../../public/images/common/post_twitter@3x.png";
/**
 * post信息
 */
export class Post {
  constructor(post) {
    this.id = post.id; // 唯一标识
    this.mediaUrl = post.media_url; // 多媒体图片
    this.proofUrl = post.proof_url; // 刪除后截圖
    this.mediaType = post.media_type; // 1 photo 2video 90 only text
    this.postTime = moment(post.post_time); // 图片发送时间
    // 格式化发送时间距离现在文案 先计算发送时间距今分钟差距
    const diffMinute = moment().diff(this.postTime, "m");
    let postStr = "";
    if (diffMinute < 60) {
      // 显示 xxx minutes ago
      postStr = `${diffMinute} minute${diffMinute > 1 ? "s" : ""} ago`;
    } else if (diffMinute < 60 * 24) {
      // 显示 xxx hours ago
      const diffHour = parseInt(diffMinute / 60);
      postStr = `${diffHour} hour${diffHour > 1 ? "s" : ""} ago`;
    } else {
      postStr = this.postTime.format("MMM DD, YYYY");
    }
    this.postStr = postStr;
    this.tzName = post.tz_name; // 时区名称
    this.likeNum = post.likes; // like数量
    this.commentNum = post.comments; // 评论数量
    this.forwardNum = post.forwards; // 转发数量
    this.viewNum = post.views; // 播放数量
    this.caption = post.caption; // caption
    this.status = post.status; // 訂單狀態
    this.storyUrl = post.story_url; // story url
    this.locationName = post.location ? post.location.name : ""; // 地理位置
    this.firstComment = post.first_comment; // first Comment
    if (post.delete_time) {
      this.deleteTime = moment(post.delete_time); // 图片发送时间
    }
    // 发送post 用户信息
    this.user = post.user;
    if (post.media_type === 90) {
      this.mediaList = [];
      if (post.user.social_network === 2 || post.user.social_network === 3) {
        if (post.story_url) {
          this.coverUrl = post.cover_url;
        } else {
          this.coverUrl = fbImage;
        }
      } else if (post.user.social_network === 4) {
        this.coverUrl = twImage;
      }
    } else {
      this.mediaList = post.medias.map((m) => {
        const result = {
          url: m.url,
          type: m.type,
          coverUrl: m.cover_url,
          product_tags: m.product_tags || [],
          usertags: m.usertags || [],
          story_mentions: m.story_mentions || [],
          story_hashtags: m.story_hashtags || [],
          location_sticker: m.location_sticker,
        };
        if (m.cover_url === null) {
          result.coverUrl = m.url;
        }
        return result;
      });
      this.coverUrl = this.mediaList[0].coverUrl;
    }
    this.state = "unknow";
    if (post.status === 20 || post.status === 21) {
      // 发送成功
      this.state = "post-success";
    } else if (post.status === 30 || post.status === 32) {
      // 发送失败
      this.state = "post-fail";
    } else if (post.status === 31) {
      this.state = "del-fail";
    } else if (post.status === 0) {
      // 等待发送
      if (post.mode === 1) {
        this.state = "post-not-auto";
      } else {
        // 自动post同样未发布
        this.state = "post-auto";
      }
    }
    // 2021.8.17 灰色状态下的 schedule 点击后不能进入 detail 页面并直接弹出付费提示
    if (post.is_active === false) {
      this.state = "post-lock";
    }
    this.insUrl = `https://www.instagram.com/${post.user.social_username}/`;
    this.facebookUrl = `https://www.facebook.com/profile.php?id=${post.user.social_uid}`;
    this.twitterUrl = `https://twitter.com/${post.user.social_username}/status/${post.media_id}`;
    this.storyUrl = post.story_url;
    this.images = [];
    if (post.medias) {
      this.images = post.medias.map((m) => {
        const image = initImage(m);
        return image;
      });
    }
    this.saved = post.saved;
    this.mediaId = post.media_id;
    this.hasVideo = false;
    this.hasVideo = this.images.findIndex((m) => m.type === 2) !== -1;
    // 新增ig tv相关字段
    this.title = post.title;
    this.igtvFeedPreview = post.igtv_feed_preview;
    this.mode = post.mode;
    this.form = new PostForm({ detail: post });
  }
}

export class PostForm {
  constructor({ detail }) {
    if (detail) {
      this.id = detail.id;
      this.caption = detail.caption;
      this.firstComment = detail.first_comment;
      this.postTime = moment(detail.post_time).format();
      if (detail.delete_time) {
        this.deleteTime = moment(detail.delete_time).format();
        // 計算postTime 和 deleteTime時間間隔
        const postTime = moment(detail.post_time);
        const deleteTime = moment(detail.delete_time);
        const minutes = deleteTime.diff(postTime, "minutes");
        // 轉化成xx 小時 xx分鐘
        this.afterTime = moment("00:00", "HH:mm")
          .add("m", minutes)
          .format("HH:mm");
      }
      this.tzName = detail.tz_name;
      if (detail.location) {
        this.location = detail.location;
      }
      // story
      if (detail.media_type === 3) {
        this.story_location = detail.location;
        this.story_caption = detail.caption;
      }
      if (detail.story_url) {
        this.story_url = detail.story_url;
      }
    }
  }
}
